export default "__VITE_ASSET__BGK2aZB1__"